// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Padding-module--cls1--1Tvx9","cls2":"styles-Padding-module--cls2--2Swep styles-Padding-module--cls1--1Tvx9"};